module.exports = __webpack_public_path__ + "static/img/ic_list.4de0aa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/ic_list.svg
// module id = lsIP
// module chunks = 10